module.exports = __webpack_public_path__ + "img/TAVI_optimised.78432bf7.gif";